import { Planzone, Identifiable, Zone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedPlanzone, LinkedZone, Linker } from "../linkers/types";
import { formatDate } from "../utils/formatDate";

function saveZone(httpClient: HttpClient, linker: Linker) {
  return (planzone: Identifiable<Planzone>, zone: Zone) =>
    new Promise<Identifiable<Zone>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<LinkedZone>({
          endpoint: `/zones`,
          method: HttpMethods.POST,
          data: {
            ...zone,
            planzone: `planzones/${planzone.uuid}`,
          },
        })
        .then(linker.linkZone)
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}
export { saveZone };
